import { Container, Col, Row } from "reactstrap";
import { BreadcrumbItem } from "reactstrap";
import { Component as Form } from "@repoflow/form-schema";
import * as Notify from "@repoflow/form-schema/notify";
import {
  Mutation,
  Button,
  useSectionContext,
} from "@repoflow/components/section";
import { CancellableContent } from "@repoflow/components/content-cancel";
import * as widgets from "widgets/register";
import * as QueriesQL from "queries/page";

export const Sidebar = () => null;

export const Indice = () => <BreadcrumbItem>Create</BreadcrumbItem>;

export const Content = ({
  history,
  match: {
    params: { siteId },
  },
}) => {
  const { base } = useSectionContext();
  // A page is NAMED and ROUTED here and composed on its own screen — the same
  // split PageInputCreate already describes ("No `elements` on create, matching
  // the archived project"). A `body` and a `slug` were both on this form once
  // and are gone from the row altogether; `route` is the field that now does
  // the naming, so it is the one that belongs beside the title.
  const initial = {
    title: "",
    route: ""
  };

  return (
    <Mutation
      initial={initial}
      target={{ $ref: "/Public/Page/Create" }}
      mutation={QueriesQL.create}
      update={QueriesQL.update({})}
      onMutate={({ handler, state: { values: input } }) => {
        handler({ variables: { siteId, input } });
      }}
      onCompleted={() => {
        history.replace(base);
      }}
      onError={(error) => {
        Notify.error(error.toString());
      }}
    >
      {MutationHandler}
    </Mutation>
  );
};

const MutationHandler = ({ target, state, schema, mutate }) => {
  const { values, setValues } = state;

  const formProps = {
    schema,
    target,
    widgets,
    onSubmit: () => {
      mutate();
    },
    onChange: (values) => {
      setValues(values);
    },
    config: {
      "/Public/Page/Create": {
        fields: [
          "title",
          "route",
        ],
      },
    },
    values,
  };

  return (
    <CancellableContent>
      <Container className="mt-4">
        <Row>
          <Col>
            <Form {...formProps}>
              <Button type="submit">Create</Button>
            </Form>
          </Col>
        </Row>
      </Container>
    </CancellableContent>
  );
};
